import { frontendURL } from '../../../helper/URLHelper';
import DealsAllIndex from './pages/DealsAllIndex.vue';
import DealsPipelineIndex from './pages/DealsPipelineIndex.vue';
import DealManageView from './pages/DealManageView.vue';
import DealNewView from './pages/DealNewView.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/deals'),
    name: 'deals_dashboard_index',
    component: DealsAllIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/deals/all'),
    name: 'deals_all',
    component: DealsAllIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/deals/pipeline/:pipelineId'),
    name: 'deals_pipeline',
    component: DealsPipelineIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/deals/new'),
    name: 'deals_new',
    component: DealNewView,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/deals/:dealId'),
    name: 'deals_edit',
    component: DealManageView,
    meta: commonMeta,
  },
];
